import React from 'react';
import { useParams } from 'react-router-dom';
import { UnifiedGameForm } from '@/components/games/unified-form/UnifiedGameForm';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';

export const UnifiedGameFormPage: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const gameType = new URLSearchParams(window.location.search).get('type') as 'regular' | 'venue' || 'regular';
  const navigate = useNavigate();
  const { permissions } = useUserRole();

  const getBackPath = () => {
    // All users should go back to My Game Forms
    return '/my-game-forms';
  };

  if (!gameId) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 pt-20">
          <div className="container mx-auto py-8">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-4">Invalid Game</h1>
              <p className="text-muted-foreground">Game ID is required</p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="px-3 py-6 md:px-6 md:py-8 max-w-7xl mx-auto">
          <div className="mb-6">
            <Button 
              variant="outline" 
              onClick={() => navigate(getBackPath())}
              className="flex items-center gap-2 h-11 md:h-10"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to Game Forms
            </Button>
          </div>
          <UnifiedGameForm gameId={gameId} gameType={gameType} />
        </div>
      </main>
      <Footer />
    </div>
  );
};